import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const GeneralInformationContent = (props) => {
  const { data } = props;

  return (
    <>
      {data && data.length
        ? data.map((item, index) => (
            <div className="group-info" key={index}>
              <div className={`group-info-head`}>
                <ul>
                  <li className="corporation-name jp-bold-600">{item.title}</li>
                </ul>
              </div>
              <div className="group-info-content" dangerouslySetInnerHTML={{__html: item.content}}>
              </div>
            </div>
          ))
        : ''}
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformationContent);
